import { useState, useEffect } from "react";
import Footer from "../components/Footer";
import Sitemap from "../components/Sitemap";
import Navbar from "../components/Navbar";
import axios from "axios";
import CountryStore from "../store/CountryStore";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

function SitemapCountryPage() {
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [selectedLetter, setSelectedLetter] = useState("");
  const setGlobalCountry = CountryStore((state) => state.setCountry);
  const navigate = useNavigate();

  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  // function show() {
  //   console.log("called the countries:", countryData);
  //   countryData.forEach((country) => {
  //     console.log(country.name + " -> " + country.vendorCount + "\n");
  //   });
  // }

  useEffect(() => {
    const fetchCountryData = async () => {
      setLoading(true);
      try {
        // console.log("Fetching country data...");
        const response = await fetch("/api/get_sub_category.php", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const text = await response.text();
        // console.log("Raw response:", text);

        // Clean the response text
        const cleanedText = text.replace(/[^{}[\],:\"\s0-9a-zA-Z]/g, "");
        // console.log("Cleaned response:", cleanedText);

        // Split the cleaned text into JSON parts
        const parts = cleanedText.split("}{");
        // console.log("Split parts:", parts);

        // Format each part into valid JSON
        const jsonParts = parts.map((part, index) => {
          if (index === 0) return part + "}";
          if (index === parts.length - 1) return "{" + part;
          return "{" + part + "}";
        });
        // console.log("JSON formatted parts:", jsonParts);

        // Parse each JSON part
        const categoryData = JSON.parse(jsonParts[0]);
        const countryData = JSON.parse(jsonParts[1]);
        const responseCountData = JSON.parse(jsonParts[2]);

        // console.log("Parsed country data:", countryData);

        // Handle country data
        if (countryData.country && Array.isArray(countryData.country)) {
          const filteredCountries = countryData.country
            .filter((item) => {
              const name = item.countryname || "";

              // Debugging: Log the current item being filtered
              // console.log(`Filtering item:`, item);

              // Check if the entry is a URL
              const isUrl = name.startsWith("http") || name.startsWith("https");

              // Check if the entry is a phone number
              const isPhoneNumber = /^\+?\d[\d\s]*$/.test(name.trim());

              // Check if the entry is a valid country name
              const isValidCountry =
                name.trim() !== "" && // Ensure name is not empty
                !isUrl && // Exclude URLs
                !isPhoneNumber && // Exclude phone numbers
                !name.startsWith("{") && // Exclude malformed entries
                !name.includes(":"); // Exclude entries with colons (e.g., JSON-like strings)

              // console.log(`Filtering: ${name} -> Valid: ${isValidCountry}`);
              return isValidCountry;
            })
            .map((item) => ({
              name: item.countryname.trim(),
              vendorCount: item.countvendor,
            }))
            .sort((a, b) => a.name.localeCompare(b.name));

          // console.log("Filtered Countries:", filteredCountries);
          setCountryData(filteredCountries);
        } else {
          console.error("No valid country data found in response");
        }
      } catch (e) {
        console.error("Error fetching or processing the response:", e);
        setCountryData([]);
      } finally {
        setLoading(false);
        // console.log("Loading complete. Country Data:", countryData);
      }
    };

    fetchCountryData();
  }, []);

  function CountryClick(country) {
    setGlobalCountry(country.name);
    const formattedCountry = country.name.replace(/\s+/g, "-").toLowerCase();
    navigate(`/sitemap/${formattedCountry}`);
  }

  function handleLetterClick(letter) {
    setSelectedLetter(letter === selectedLetter ? "" : letter);
  }

  function handleAllClick() {
    setSelectedLetter("");
  }

  const filteredCountries = selectedLetter
    ? countryData.filter((country) =>
        country.name.toUpperCase().startsWith(selectedLetter)
      )
    : countryData;

  return (
    <div className="font-inter flex flex-col min-h-screen overflow-hidden">
      <Navbar />
      <div className="container mx-auto px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 2xl:px-24">
        <div className="flex flex-wrap gap-2 justify-center my-6">
          <button
            onClick={handleAllClick}
            className={`w-12 h-8 rounded-full border ${
              selectedLetter === ""
                ? "bg-gray-200 text-black"
                : "hover:bg-gray-100 text-gray-700"
            } flex items-center justify-center text-sm font-medium transition-colors`}
          >
            All
          </button>
          {alphabet.map((letter) => (
            <button
              key={letter}
              onClick={() => handleLetterClick(letter)}
              className={`w-8 h-8 rounded-full border ${
                selectedLetter === letter
                  ? "bg-gray-200 text-black"
                  : "hover:bg-gray-100 text-gray-700"
              } flex items-center justify-center text-sm font-medium transition-colors`}
            >
              {letter}
            </button>
          ))}
        </div>
        {loading ? (
          <div className="absolute inset-0 flex justify-center items-center">
            <ClipLoader color="#006b4f" size={35} speedMultiplier={1} />
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-4">
            {filteredCountries.map((country, index) => (
              <button
                key={index}
                className="text-[#9CA3AF] text-left cursor-default break-words"
              >
                <span
                  className="cursor-pointer hover:text-black"
                  onClick={() => CountryClick(country)}
                >
                  {country.name} ({country.vendorCount})
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default SitemapCountryPage;